import React from "react";
import { Colors } from "../../Constants/colors";
import { DropdownOptions } from "../dropdownOptions";
import { CheckBox } from "../input/CheckBox";
import { Separator } from "../Separator";
import { TextBtnType, TextButton } from "../Button/TextButton";

export interface MultiOptions {
  optionsTitle: string;
  category: string;
  options: DropdownOptions[];
}

interface Props {
  dropdownOptions: MultiOptions[];
  showDropdown: boolean;
  onOptionsSelected: (selectedData: DropdownOptions) => unknown;
  selectedOptions: DropdownOptions[] | null;
  setOptions: (options: DropdownOptions[]) => unknown;
}

export const MultiDropdownOptions = ({
  dropdownOptions,
  showDropdown,
  onOptionsSelected,
  selectedOptions,
  setOptions,
}: Props) => {
  if (!showDropdown) return <></>;

  const handleSelectAll = ({ category }: { category: string }) => {
    const allOptionsOfCategory = dropdownOptions.find(
      ({ category: dropdownCategory }) => dropdownCategory === category
    );
    if (allOptionsOfCategory) {
      const newOptions = allOptionsOfCategory.options;
      setOptions([...(selectedOptions || []), ...newOptions]);
    }
  };
  const handleClearAll = ({ category }: { category: string }) => {
    const categoriesItem =
      (selectedOptions || []).filter(
        ({ category: dropdownCategory }) =>
          (dropdownCategory || "") !== category
      ) || [];
    setOptions([...(categoriesItem || [])]);
  };

  const buildActionItem = ({ category }: { category: string }) => {
    const categoriesArr: { [key: string]: any } = {};
    (selectedOptions || []).forEach(({ value: selectedValue }) => {
      (dropdownOptions || []).forEach(({ category, options }) => {
        const foundIndex = options.findIndex(
          ({ value: dropDownValue }) => selectedValue === dropDownValue
        );
        if (foundIndex >= 0) {
          if (!categoriesArr[category]) {
            categoriesArr[category] = [];
          }
          categoriesArr[category].push(selectedValue);
        }
      });
    });

    const hasOptionsFromCategory = (categoriesArr[category] || []).length;
    return (
      <TextButton
        type={
          !hasOptionsFromCategory ? TextBtnType.primary : TextBtnType.danger
        }
        title={!hasOptionsFromCategory ? "Select all" : "Clear all"}
        onClick={() => {
          !hasOptionsFromCategory
            ? handleSelectAll({ category })
            : handleClearAll({ category });
        }}
      />
    );
  };

  return (
    <div
      className="flex flex-col p-4 gap-y-2 rounded-md"
      style={{
        position: "absolute",
        top: "calc(100% + 10px)",
        zIndex: 999,
        width: "100%",
        border: `1px solid ${Colors.LightAshRose}`,
        backgroundColor: Colors.White,
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        cursor: "pointer",
      }}
    >
      {dropdownOptions.map(({ optionsTitle, category, options }, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-row items-center justify-between">
            <div className="text-sm" style={{ color: Colors.AshRose }}>
              {optionsTitle}
            </div>
            <div>{buildActionItem({ category })}</div>
          </div>

          <Separator />

          {options.map((option, optIndex) => (
            <div
              key={optIndex}
              className="flex flex-row gap-2 content-center items-center pl-2 pr-2"
            >
              <div>
                <CheckBox
                  isChecked={
                    !!selectedOptions?.find(
                      ({ value }) => value === option.value
                    )
                  }
                  setIsChecked={() => {
                    onOptionsSelected(option);
                  }}
                />
              </div>
              <div
                className="text-sm"
                style={{
                  color: Colors.Grey,
                  height: "100%",
                }}
              >
                {option.text}
              </div>
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default MultiDropdownOptions;
